import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'smart-rate.title',
    defaultMessage: 'SmartRate',
  },
  faqTitle: {
    id: 'smart-rate.faq.title',
    defaultMessage: 'Frequently asked questions',
  },
});
